import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, withRouter } from "react-router-dom";
import Button from '../components/Button';
import { getCookie } from '../../utils/cookies';


const TOSAcceptance = ({ location }) => {
  const [showModal, setShowModal] = useState(false);

  const { t } = useTranslation();
  const language = getCookie('i18next') || getCookie('locale') || 'en';
  
  const handleAcceptTOS = () => { 
    axios.patch('/api/v1/influencers/users/tos_accept')
      .then(({ data }) => {
        if (data.success === true) {
          setShowModal(false);
        }
      }).catch(err => {
        console.log(err);
      });
  }

  const tosAccepted = () => {
    axios.get(`/api/v1/influencers/users/tos_accepted?locale=${language}`)
    .then(({ data }) => {
      if (data.tos_accepted !== true) {
        setShowModal(true);
      } else {
        console.log('accepted');
      }
    }).catch(err => {
      console.log(err);
    });
  };

  useEffect(() => {
    tosAccepted();
  }, [language]);

  if(location.pathname === '/terms-of-service') {
    return '';
  } else {
    return (<Modal show={showModal} backdrop='static' centered>
      <Modal.Header>
        <Modal.Title>{t('influencers.pages.tos_acceptance.notice')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t('influencers.pages.tos_acceptance.our')} <Link to='/terms-of-service' target="_blank" rel="noopener noreferrer">
          {t('influencers.pages.tos_acceptance.terms_and_conditions')}
        </Link> {t('influencers.pages.tos_acceptance.have_changed')}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleAcceptTOS}>Accept</Button>
      </Modal.Footer>
    </Modal>)
  }
}

const mapStateToProps = (state) => ({ user: state.auth.user });

export default withRouter(connect(mapStateToProps)(TOSAcceptance));
